import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-common-search',
  templateUrl: './common-search.component.html',
  styleUrls: ['./common-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CommonSearchComponent {

  @Input() inputPlaceholder: string;
  @Input() disabled = false;
  @Output() searchText: any = new EventEmitter();
  @Output() clearSearch: any = new EventEmitter();
  @Output() enterKeyPress: EventEmitter<string> = new EventEmitter();
  searchValue: string = '';

  search(searchValue: string) {
    this.searchText.emit(searchValue.trim());
  }

  clearFilterSearch() {
    this.searchValue = '';
    this.clearSearch.emit('');
  }

  clearInputValue() {
    this.searchValue = '';
  }

  onEnterPress(value: string) {
    const val = value.trim();
    val && this.enterKeyPress.emit(val);
  }
}
